// extracted by mini-css-extract-plugin
export var orderDetails = "_rm-2";
export var orderImage = "_rm-1";
export var orderMeta = "_rm-3";
export var orderSummary = "_rm-0";
export var rightArrow = "_rm-4";